const messaging = () => ({
  setBackgroundMessageHandler: () => {},
  onMessage: () => () => {},
  getToken: () => Promise.resolve(''),
  deleteToken: () => Promise.resolve(),
  requestPermission: () => Promise.resolve(1),
  hasPermission: () => Promise.resolve(1),
  subscribeToTopic: () => Promise.resolve(),
  unsubscribeFromTopic: () => Promise.resolve(),
  onTokenRefresh: () => () => {},
  setAPNSToken: () => Promise.resolve(),
  getAPNSToken: () => Promise.resolve(null),
});

messaging.isSupported = () => false;

// Mirrors @react-native-firebase/messaging AuthorizationStatus enum.
// Sendbird's createNativeNotificationService reads messagingModule.AuthorizationStatus.AUTHORIZED.
messaging.AuthorizationStatus = {
  NOT_DETERMINED: -1,
  DENIED: 0,
  AUTHORIZED: 1,
  PROVISIONAL: 2,
};

export default messaging;
export const AuthorizationStatus = messaging.AuthorizationStatus;
